import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setBenefitPlanOptions = ({ planId, ...payload }) =>
  call(websocketFetch, 'set_benefit_plan_options', {
    plan_id: planId,
    ...payload,
  });
